import { supabase } from "../lib/supabase";

export async function fetchCityLaunchControls() {
  const { data, error } = await supabase
    .from("city_launch_controls")
    .select("*")
    .order("city_name", { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function updateCityLaunchControl(id, payload) {
  const { error } = await supabase
    .from("city_launch_controls")
    .update({
      ...payload,
      updated_at: new Date().toISOString(),
    })
    .eq("id", id);

  if (error) throw error;
  return true;
}